import { createContext, useContext } from 'react'

/**
 * A back interceptor returns `true` when it has handled (consumed) the back
 * action, so the questionnaire should NOT navigate to the previous question.
 */
export type QuestionnaireBackInterceptor = () => boolean

type QuestionnaireBackInterceptorContextValue = {
  setBackInterceptor: (interceptor: QuestionnaireBackInterceptor | null) => void
}

const QuestionnaireBackInterceptorContext = createContext<QuestionnaireBackInterceptorContextValue | null>(null)

export const QuestionnaireBackInterceptorProvider = QuestionnaireBackInterceptorContext.Provider

const noop = () => {}

/**
 * Lets the active question intercept the questionnaire's shared back action
 * (header button, swipe and `onPrevious` all route through it). While an
 * interceptor is registered, back is handed to it first; the medication and
 * allergy questions use this to return from their add-flow to the initial
 * choice instead of leaving the question. Returns a no-op when rendered
 * outside the provider.
 */
export const useQuestionnaireBackInterceptor = () => {
  const context = useContext(QuestionnaireBackInterceptorContext)
  return context?.setBackInterceptor ?? noop
}
